import React from 'react';

import {
  currency,
  fallbackText,
  perHour,
  PharmacistLegendVariant,
  PharmacyLegendVariant,
  TimeFormat,
} from '@pharmaplan/common';

import ViewAllLongTermContracts from '../components/ViewAllLongTermContracts';
import { setDialog } from '../reducers/dialogReducer';
import { store } from '../store';

import { formatDateRange, formatDateTimeRange } from './Functions';
import { DynamicTableCell } from './Constants';
import { getDayMonthDateYear } from '../components/Reports/helpers';

export const dateRecord = (
  {
    startDate,
    endDate,
    timeFormat,
  }: { startDate: string; endDate?: string; timeFormat?: TimeFormat },
  type: PharmacistLegendVariant | PharmacyLegendVariant,
  longTermShiftContractId?: string,
  professionalId?: string,
) => {
  if (!endDate) {
    const date = startDate ? getDayMonthDateYear(startDate) : fallbackText;

    return {
      key: '4~',
      value: date,
      type: DynamicTableCell.text,
    };
  }

  if (!longTermShiftContractId) {
    return {
      key: '4~',
      value: formatDateTimeRange(
        startDate,
        endDate,
        timeFormat ?? TimeFormat.twentyFourHours,
      ),
      type: DynamicTableCell.text,
    };
  }

  const openDialog = () => {
    store.dispatch(
      setDialog({
        Component: (
          <ViewAllLongTermContracts
            longTermContractId={longTermShiftContractId}
            type={type}
            professionalId={professionalId}
          />
        ),
        heading: {
          title: '',
        },
        maxWidth: 'lg',
        showCloseButton: true,
      }),
    );
  };

  return {
    key: '4',
    value: {
      label: formatDateRange(startDate, endDate),
      handlePress: openDialog,
    },
    type: DynamicTableCell.customLink,
  };
};

export const rateRecord = (
  {
    weekDayPaidHourlyRate,
    weekendPaidHourlyRate,
    rate,
  }: {
    rate: number;
    weekDayPaidHourlyRate?: number;
    weekendPaidHourlyRate?: number;
  },
  longTermShiftContractId?: string,
) => {
  if (!longTermShiftContractId) {
    return {
      key: '8~',
      value: `${currency}${rate} ${perHour}`,
      type: DynamicTableCell.text,
    };
  }

  return {
    key: '8~',
    value: `${currency}${weekDayPaidHourlyRate}${perHour}, ${currency}${weekendPaidHourlyRate}${perHour}`,
    type: DynamicTableCell.text,
  };
};
